query allSoccerTeams(
  $first: Int,
  $offset: Int,
  $filter: SoccerTeamFilter,
  ) {
  teams: allSoccerTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamMappings: soccerTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
        name
        source
        teamId
    }
    totalCount
  }
}
